// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__UF-gS","footer__container":"footer_footer__container__ssLdw","footer__text":"footer_footer__text__QBIy5","footer__list":"footer_footer__list__-+3kt"};